import { render, staticRenderFns } from "./MissedRequests.vue?vue&type=template&id=3965a194&scoped=true"
import script from "./MissedRequests.vue?vue&type=script&lang=js"
export * from "./MissedRequests.vue?vue&type=script&lang=js"
import style0 from "./MissedRequests.vue?vue&type=style&index=0&id=3965a194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965a194",
  null
  
)

export default component.exports